function mapTimelineCoverImage(url, rotation) {
  return buildRotatedImageUrl(url, {format: 'jpg', rotation});
}

export function timelinePeriodMapper(period) {
  const rotation = period.images?.rotation;
  const dimensions = getRotatedImageDimensions({
    width: period.images?.preview_width,
    height: period.images?.preview_height,
    rotation
  });

  period.coverImage = mapTimelineCoverImage(period.images?.preview, rotation);
  period.coverImageLarge = mapTimelineCoverImage(period.images?.original, rotation);
  period.coverImageWidth = dimensions.width;
  period.coverImageHeight = dimensions.height;

  if (Array.isArray(period.periods)) {
    period.periods = period.periods.map(timelinePeriodMapper);
  }

  return period;
}
